<template>
    <TooltipComp
        v-if="text"
        :text="text"
        :placement="position"
    >
        <WarnIcon />
    </TooltipComp>
</template>
<script lang="ts" setup>
import { WarnIcon, TooltipComp } from '@/components';

withDefaults(
    defineProps<{
        text?: string;
        position?: 'top' | 'bottom' | 'left' | 'right';
    }>(),
    { position: 'right' },
);
</script>
